import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../services/common.service';
import { SickLeaveListService } from '../services/sick-leave-list.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {

  error;
  d;
  month_names;
  month_name;
  month;
  year;
  first_date;
  tmp;
  first_day;
  day_name;
  day_no;
  days;
  days_name_array;
  empty_days = [];
  second_row = [];
  third_row = [];
  fourth_row = [];
  fifth_row = [];
  @Input() calDate = '09/23/2018';
  @Input('startDate') leaveStartDate = '9/12/2018';
  @Input('endDate') leaveEndDate = '9/26/2018';
  @Input() empid;
  startDate;
  endDate;
  start_leave_day;
  end_leave_day;

  currentIndex: number;
  firstIndex: number;
  lastIndex: number;
  currentMonth;
  currentYear;

  holidayFlag;
  workdaysFlag;

  calendarArray = [];
  holidaysDates = [];
  holidaysDatesCopy = [];

  workingDayDates = [];
  LeaveDates = [];

  constructor(public commonService: CommonService, public sickLeaveListService: SickLeaveListService) { }

  dateForService(parameter, startOrEnd) {
    let date = new Date(parameter);
    let m: any = date.getMonth() + 1;
    let y: any = date.getFullYear();
    let d: any;

    if (startOrEnd === 'start') {
      d = '01'.toString();
    } else {
      d = new Date(y, m, 0).getDate().toString();
    }
    if (m.toString().length === 1) {
      m = '0' + m.toString();
    }
    return m.toString() + "/" + d.toString() + "/" + y.toString();
  }

  ngOnInit() {
    this.error = true;
    this.holidayFlag = true;
    this.workdaysFlag = true;
    const date1 = new Date(this.leaveStartDate);
    const date2 = new Date(this.leaveEndDate);
    const startYear = date1.getFullYear();
    const endYear = date2.getFullYear();
    const startMonth = date1.getMonth();
    const endMonth = date2.getMonth();

    const startDateForService = this.dateForService(this.leaveStartDate, 'start');
    const endDateForService = this.dateForService(this.leaveEndDate, 'end');

    this.commonService.getHolidaysList(startDateForService, endDateForService)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            this.holidaysDates = [];
            this.holidaysDatesCopy = [];
            this.holidaysDates = res.response;
            this.holidaysDates.forEach(element => {
              this.holidaysDatesCopy.push(element.holidaydate);
            });
            this.holidayFlag = false;
          } else {
            this.error = false;
            this.holidayFlag = true;
            this.holidaysDates = [];
            this.holidaysDatesCopy = [];
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          this.error = false;
          this.holidayFlag = true;
          this.holidaysDates = [];
          this.holidaysDatesCopy = [];
        }
      );

    if (this.empid.toString().toLocaleLowerCase().startsWith('u')) {
      this.empid = this.empid.substring(1);
    }

    this.commonService.getWorkdaysList(this.empid, startDateForService, endDateForService, 'Work')
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            this.workingDayDates = [];
            this.workingDayDates = res.response.WorkingDayDates;
            this.workdaysFlag = false;
          } else {
            this.error = false;
            this.workdaysFlag = true;
            this.workingDayDates = [];
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          this.error = false;
          this.workdaysFlag = true;
          this.workingDayDates = [];
        });

    this.currentIndex = 0;
    this.firstIndex = 0;
    this.calendarArray = [];
    this.month_names = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'];
    let temp = {
      'startDate': '',
      'endDate': ''
    };

    if (startYear === endYear) {
      if (startMonth === endMonth) {
        temp.startDate = this.leaveStartDate;
        temp.endDate = this.leaveEndDate;
        this.calendarArray.push(temp);
      } else {
        temp.startDate = this.leaveStartDate;
        temp.endDate = (startMonth + 1) + '/' + new Date(startYear, startMonth + 1, 0).getDate() + '/' + startYear;
        this.calendarArray.push(temp);

        for (let i = startMonth + 2; i <= endMonth; i++) {
          temp = {
            'startDate': '',
            'endDate': ''
          };
          const tempEndDate = new Date(startYear, i, 0).getDate();
          temp.startDate = i + '/01/' + startYear;
          temp.endDate = i + '/' + tempEndDate + '/' + startYear;
          this.calendarArray.push(temp);
        }
        temp = {
          'startDate': '',
          'endDate': ''
        };
        temp.startDate = (endMonth + 1) + '/01' + '/' + startYear;
        temp.endDate = this.leaveEndDate;
        this.calendarArray.push(temp);
      }
    } else {
      const diff = endYear - startYear;
      temp.startDate = this.leaveStartDate;
      temp.endDate = (startMonth + 1) + '/' + new Date(startYear, startMonth + 1, 0).getDate() + '/' + startYear;
      this.calendarArray.push(temp);
      for (let i = startMonth + 2; i <= 12; i++) {
        temp = {
          'startDate': '',
          'endDate': ''
        };
        const tempEndDate = new Date(startYear, i, 0).getDate();
        temp.startDate = i + '/01/' + startYear;
        temp.endDate = i + '/' + tempEndDate + '/' + startYear;
        this.calendarArray.push(temp);
      }
      for (let j = startYear + 1; j < endYear; j++) {
        for (let k = 1; k <= 12; k++) {
          temp = {
            'startDate': '',
            'endDate': ''
          };
          const tempEndDate = new Date(j, k, 0).getDate();
          temp.startDate = k + '/01/' + j;
          temp.endDate = k + '/' + tempEndDate + '/' + j;
          this.calendarArray.push(temp);
        }
      }
      for (let k = 1; k <= endMonth; k++) {
        temp = {
          'startDate': '',
          'endDate': ''
        };
        const tempEndDate = new Date(endYear, k, 0).getDate();
        temp.startDate = k + '/01/' + endYear;
        temp.endDate = k + '/' + tempEndDate + '/' + endYear;
        this.calendarArray.push(temp);
      }
      temp = {
        'startDate': '',
        'endDate': ''
      };
      temp.startDate = (endMonth + 1) + '/01' + '/' + endYear;
      temp.endDate = this.leaveEndDate;
      this.calendarArray.push(temp);
    }

    this.lastIndex = this.calendarArray.length - 1;
    this.startDate = this.calendarArray[0].startDate;
    this.endDate = this.calendarArray[0].endDate;
    this.createCalendar(this.calendarArray[0].startDate);
  }

  toNext() {
    if (this.currentIndex < this.lastIndex) {
      this.currentIndex++;
      this.startDate = this.calendarArray[this.currentIndex].startDate;
      this.endDate = this.calendarArray[this.currentIndex].endDate;
      this.currentMonth = new Date(this.startDate).getMonth() + 1;
      this.currentYear = new Date(this.startDate).getFullYear();
      this.createCalendar(this.startDate);
    }
  }
  toPrev() {
    if (0 < this.currentIndex) {
      this.currentIndex--;
      this.startDate = this.calendarArray[this.currentIndex].startDate;
      this.endDate = this.calendarArray[this.currentIndex].endDate;
      this.createCalendar(this.startDate);
    }
  }

  isInTheArray(item, array) {
    let temp = '';
    if (item.trim().length === 1) {
      item = '0'.toString() + item.toString();
    }
    if (this.currentMonth.toString().length === 1) {
      temp = '0'.toString() + this.currentMonth.toString() + '/' + item.toString() + '/' + this.currentYear.toString();
    } else {
      temp = this.currentMonth.toString() + '/' + item.toString() + '/' + this.currentYear.toString();
    }
    return array.indexOf(temp) !== -1 ? true : false;
  }

  createCalendar(createCalendarFor) {
    this.d = new Date(createCalendarFor);
    this.currentMonth = this.d.getMonth() + 1;
    this.currentYear = this.d.getFullYear();
    this.start_leave_day = new Date(this.startDate).getDate();
    this.end_leave_day = new Date(this.endDate).getDate();
    this.month = this.d.getMonth();
    this.month_name = this.month_names[this.month];
    this.year = this.d.getFullYear();
    this.first_date = this.month_names[this.month] + ' ' + 1 + ' ' + this.year;
    this.tmp = new Date(this.first_date).toDateString();
    this.first_day = this.tmp.substring(0, 3);
    this.day_name = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    this.days_name_array = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    this.day_no = this.day_name.indexOf(this.first_day);
    this.days = new Date(this.year, this.month + 1, 0).getDate();
    for (let i = 0; i < this.day_no; i++) {
      this.empty_days[i] = ' ';
    }
    let count = 1;
    for (let i = this.day_no; i <= 6; i++) {
      this.empty_days[i] = '' + count;
      count++;
    }
    let temp = count + 6;
    let temp_count = 0;
    for (let i = count; i <= temp; i++) {
      this.second_row[temp_count] = '' + i;
      temp_count++;
      count++;
    }
    temp = count + 6;
    temp_count = 0;
    for (let i = count; i <= temp; i++) {
      this.third_row[temp_count] = '' + i;
      temp_count++;
      count++;
    }
    temp = count + 6;
    temp_count = 0;
    for (let i = count; i <= temp; i++) {
      this.fourth_row[temp_count] = '' + i;
      temp_count++;
      count++;
    }
    temp = count + 6;
    temp_count = 0;
    for (let i = count; i <= temp; i++) {
      if (count <= this.days) {
        this.fifth_row[temp_count] = '' + i;
        temp_count++;
        count++;
      } else {
        if (count > this.days) {
          this.fifth_row[temp_count] = '';
          temp_count++;
          count++;
        }
      }
    }
    if (count <= this.days) {
      for (let i = 0; i < this.day_no; i++) {
        this.empty_days[i] = '' + count;
        count++;
        if (count > this.days) {
          break;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/calendar.component.ts